module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "desktop-header"
  }, [_c('div', {
    staticClass: "desktop-header__container mx-auto"
  }, [_c('div', {
    staticClass: "desktop-header-logo float-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ct-learning-logo.png",
      "alt": "app logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "desktop-header-nav float-left"
  }, [_c('nav', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item",
    class: {
      'desktop-header-nav__item--active': _vm.navState === 'perf'
    }
  }, [_vm._v("\n            학습 분석\n          ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/badges"
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item",
    class: {
      'desktop-header-nav__item--active': _vm.navState === 'badges'
    }
  }, [_vm._v("\n            미션 현황\n          ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.ctStoreUrl
    }
  }, [_c('div', {
    staticClass: "desktop-header-nav__item"
  }, [_vm._v("맞춤 학습")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "desktop-header-profile float-right"
  }, [_c('a', {
    staticClass: "desktop-header-profile__image",
    style: (_vm.profileImageStyle),
    attrs: {
      "href": _vm.userProfileUrl,
      "target": "_blank"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cdf93d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DesktopHeader.vue
// module id = 1596
// module chunks = 1